import { BrowserModule } from '@angular/platform-browser';
import { NgModule} from '@angular/core';
         
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsProviderModule } from './icons-provider.module';
import { FormsModule } from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {HashLocationStrategy, LocationStrategy, registerLocaleData} from '@angular/common';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import zh from '@angular/common/locales/zh';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {NgxEchartsModule} from "ngx-echarts";
import {NzMenuModule} from "ng-zorro-antd/menu";
import {NzToolTipModule} from "ng-zorro-antd/tooltip";
import {NzIconModule} from "ng-zorro-antd/icon";
import {NzLayoutModule} from "ng-zorro-antd/layout";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzDropDownModule} from "ng-zorro-antd/dropdown";
import {NZ_I18N, zh_CN} from "ng-zorro-antd/i18n";
import {HttpBaseConfig, FrontCommonToolkitsModule, StorageService} from "front-common-toolkits";
import {environment} from "../environments/environment";
import {NzNotificationService} from "ng-zorro-antd/notification";
import {NzMessageService} from "ng-zorro-antd/message";
import {NzModalService} from "ng-zorro-antd/modal";
import {LayoutModule} from "./module/layout/layout.module";
import {LoginModule} from "./pages/login/login.module";
import {NZ_CONFIG, NzConfig} from "ng-zorro-antd/core/config";
import {TokenInterceptor} from "./guards/token.interceptor";
import {AuthGuard} from "./guards/auth.guard";



//ngrx
import {StoreModule} from "@ngrx/store";
import {reducer as rolesReducer} from "./services/state/reduces/roles.reducer";
import {reducer as roleLoadedReducer} from "./services/state/reduces/roleLoaded.reducer";
import {reducer as userReducer} from "./services/state/reduces/user.reducer";
import {reducer as shrinkReducer} from "./services/state/reduces/shrink.reducer";
import {reducer as bpmnReducer} from "./services/state/reduces/bpmn.reducer";
 
import {AuthenticationService} from "./services/utils/authentication.service";
import {NotFoundPageComponent} from "./pages/not-found-page/not-found-page.component";
import { LoginRedirectionComponent } from './pages/login-redirection/login-redirection.component';

registerLocaleData(zh);

export function createTranslateHttpLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const ngZorroConfig: NzConfig = {
  // 注意组件名称没有 nz 前缀
  notification: { nzMaxStack: 1 },
  message: { nzMaxStack: 1 },
  table: {nzSize: 'small', nzBordered: true},
  modal: {nzMaskClosable: false}
};

const httpBaseSettings: HttpBaseConfig = {   
  httpBase: environment.isAdmin ? environment.httpBase : environment.tenantHttpBase,
  organizationId: -1
};

@NgModule({   
  declarations: [
    AppComponent,
    NotFoundPageComponent,
    LoginRedirectionComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    IconsProviderModule,
    FormsModule,
    HttpClientModule,
    NgxEchartsModule,
    LoginModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateHttpLoader),
        deps: [HttpClient]
      }
    }),
    FrontCommonToolkitsModule.forRoot(httpBaseSettings),
    BrowserAnimationsModule,
    NzMenuModule,
    NzToolTipModule,
    NzIconModule,
    NzLayoutModule,    
    NzButtonModule,
    NzDropDownModule,  
    LayoutModule,
    StoreModule.forRoot({   
      roles: rolesReducer,
      roleLoaded:roleLoadedReducer,
      user:userReducer,
      shrink:shrinkReducer,
      bpmn:bpmnReducer,
    })
  ],
  providers: [
    AuthenticationService,
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {provide: NZ_CONFIG, useValue: ngZorroConfig},
    {provide: NZ_I18N, useValue: zh_CN},
    AuthGuard,
    NzNotificationService,
    NzMessageService,
    NzModalService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
